import { ApplicationConfig, importProvidersFrom, Injectable, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PrevilegeAuthorizationModule } from './authorization/authorization.module';
import { AuthorizationConfig } from './authorization/privilege-authorization.modal';
import { MsalConfigDynamicModule } from './msal-config-dynamic.module';
import { LocalTranslationService } from './core/services/local-translate.service';
import { appReducers } from './receiving/shared/store-management/reducers/app.reducer';
import { ApiInterceptorService } from './core/services/api-interceptor.service';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReactiveFormsModule } from '@angular/forms';

// APP_INITIALIZER factory: processes the Azure AD redirect response BEFORE
// Angular's router initialNavigation clears the ?code=... query params from the URL.
// Without this, the auth code is lost when Angular routes to /#/login.
export function msalRedirectInitializer(msalService: MsalService, _broadcastService: MsalBroadcastService): () => Promise<void> {
  return async () => {
    await msalService.instance.initialize();
    await msalService.handleRedirectObservable().toPromise();
  };
}

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  override overrides = <any>{
    'pinch': { enable: false },
    'rotate': { enable: false },
    'swipe': { 'directions': 'DIRECTION_HORIZONTAL' }
  };
}

const previlegeModal: AuthorizationConfig = {
  previlege: [],
  previlegeModule: null
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: msalRedirectInitializer,
      deps: [MsalService, MsalBroadcastService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptorService,
      multi: true
    },
    Store,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig
    },
    LocalTranslationService,
    importProvidersFrom(
      CoreModule,
      MatProgressSpinnerModule,
      ReactiveFormsModule,
      HammerModule,
      NgbModule,
      NgIdleKeepaliveModule.forRoot(),
      ToastrModule.forRoot({ maxOpened: 1, autoDismiss: true }),
      StoreModule.forRoot(appReducers, {
        runtimeChecks: {
          strictStateImmutability: false,
          strictActionImmutability: false,
        }
      }),
      EffectsModule.forRoot([]),
      SharedModule,
      PrevilegeAuthorizationModule.forRoot(previlegeModal),
      MsalConfigDynamicModule.forRoot('assets/appsettings.json'),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: LocalTranslationService,
          deps: [HttpClient]
        }
      })
    )
  ]
};
